import { instance as axios } from "./baseUrl";

export const registerAccountApi = (data) => axios.post("public/register/tenant", { ...data });

export const validateAccountApi = (accountUUID) => axios.get(`public/verify-account?p1=${accountUUID}`);

export const validateEmailApi = (emailData) =>axios.get(`public/valid-email-public?email=${emailData.email}`);

export const validatePhoneApi = (phoneData) =>
    axios.get(`public/valid-tenant-phone?phoneNumber=${phoneData.phoneNumber}&countryCode=${phoneData.countryCode}`);


